import { render, staticRenderFns } from "./news25.vue?vue&type=template&id=20c6bb3c&"
import script from "./news25.vue?vue&type=script&lang=js&"
export * from "./news25.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports